import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogoLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={36}
    height={36}
    fill='none'
    {...props}
  >
    <g clipPath='url(#Logo-light_svg__a)'>
      <path
        fill='#090E1B'
        d='M18 0C8.06 0 0 8.06 0 18s8.06 18 18 18 18-8.06 18-18S27.94 0 18 0m9.144 30.695a35.7 35.7 0 0 1-18.279-.007c-4.826-1.278-7.7-6.255-6.399-11.075a35.87 35.87 0 0 1 9.126-15.858c3.521-3.561 9.3-3.561 12.818 0a35.9 35.9 0 0 1 9.128 15.865c1.299 4.817-1.57 9.792-6.392 11.072z'
      />
    </g>
    <defs>
      <clipPath id='Logo-light_svg__a'>
        <path fill='#fff' d='M0 0h36v36H0z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoLight;
